// src/app/pages/view-templates/business-groups.resolver.ts
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { firstValueFrom,} from 'rxjs';
import { WelodgeService } from '../../../services/welodge.service';
import { TokenService } from '../../../services/token.service';

export const docTypesResolver: ResolveFn<any[]> = async () => {
  const wl = inject(WelodgeService);
  const tokens = inject(TokenService);

  const token = tokens.getToken();
  if (!token) throw new Error('Missing token');
  const resp: any = await firstValueFrom(
    wl.getDocumentBodyTemplatesId()
  );

  console.log('docTypesResolver', resp);

  return resp?.TemplateTypes?? [];
};
